import React, { createContext, useState } from "react";

export const CartCountContext = createContext();

export const CartCountProvider = ({ children }) => {
  const [cartCount, setCartCount] = useState(0);

  const incrementCartCount = () => {
    setCartCount((prevCount) => prevCount + 1);
  };

  return (
    <CartCountContext.Provider value={{ cartCount, incrementCartCount }}>
      {children}
    </CartCountContext.Provider>
  );
};
